<template>
  <b-modal
      id="add-project-modal"
      ref="add-project-modal"
      scrollable
      modal-class="unit_modal"
      :title="current_project ?  trans('common.Settings_project') : trans('common.Add_project')"
      :ok-title="current_project ? trans('common.Save_txt') : trans('common.Add_txt')"
      :cancel-title="trans('common.Cancel_txt')"
      @close="resetValidations"
      @hidden="resetValidations"
      @ok.prevent="handleOk"
      centered
  >
    <div class="">
      <div class="">
        <b-form-group :label="trans('labels.Name_company')" :invalid-feedback="validations.company_title">
          <b-form-input v-model="edit.company_title" type="text" :state="isState(validations.company_title)" :placeholder="trans('labels.Enter_name')" required></b-form-input>
        </b-form-group>
        <b-form-group :label="trans('labels.Name_project')" :invalid-feedback="validations.title">
          <b-form-input v-model="edit.title" type="text" :state="isState(validations.title)" :placeholder="trans('labels.Enter_name')" required></b-form-input>
        </b-form-group>
        <b-form-group :label="getUserLbl(i + 1)" :key="i" v-for="(val, i) in this.edit.users" :invalid-feedback="trans('labels.Select_recruiter')" :class="{'flex_row': i > 0}">
          <b-form-select type="text" :placeholder="trans('labels.Enter_name')" v-model="edit.users[i]" :state="validations.users_invalid.includes(i) ? false : null"
                         :options="userOptions(val)" :disabled="disableIsSelectRecruit"></b-form-select>
          <i v-if="i > 0 && !disableIsSelectRecruit" class="icon-trash" @click="() => deleteUser(i)"></i>
        </b-form-group>
        <button class="add_user_btn_container no_btn mb-4" @click="addUser" :disabled="disableAddButton" v-show="!disableAddButton">
          <collapse-plus/>
          {{ trans('labels.Add_recruiter') }}
        </button>
        <div class="common_groups_block mb-3">
          <span> {{ trans('labels.Address_office') }}</span>
          <b-form-textarea v-model="edit.office_address" :placeholder="trans('labels.Enter_address_office')"></b-form-textarea>
        </div>
        <b-form-group :label="trans('labels.Currency')"><b-form-select v-model="edit.currency" :options="get_options(this.currencies)"></b-form-select></b-form-group>
        <b-form-group :label="trans('labels.Timezone+')">
          <b-form-select v-model="edit.timezone" :options="timeZoneOptions"></b-form-select>
        </b-form-group>
        <b-form-group :label="trans('labels.Language')">
          <b-form-select v-model="edit.lang" :options="[{'value': 'RUS','text':trans('labels.Russian')}, {'value': 'ENG','text':trans('labels.England')}]"></b-form-select>
        </b-form-group>
        <b-form-group label="Страна">
          <b-form-select v-model="edit.country_id" :options="get_options(this.countries)"></b-form-select>
        </b-form-group>
      </div>
    </div>
  </b-modal>
</template>

<script>
import CollapsePlus from "../../components/common/collapse-plus";

export default {
  name: "addProjectModal",
  props: ['current_project'],
  components: {CollapsePlus},
  computed: {
    disableIsSelectRecruit(){
      return this.$store.getters.getIsChild && this.$store.getters.getUserId != this.current_project?.owner_id
    },
    timeZoneOptions() {
      return [
        {value:-12, text: 'UTC -12'}, {value:-11, text: 'UTC -11'}, {value:-10, text: 'UTC -10'},
        {value:-9, text: 'UTC -9'}, {value:-8, text: 'UTC -8'}, {value:-7, text: 'UTC -7'},
        {value:-6, text: 'UTC -6'}, {value:-5, text: 'UTC -5'}, {value:-4, text: 'UTC -4'},
        {value:-3, text: 'UTC -3'}, {value:-2, text: 'UTC -2'}, {value:-1, text: 'UTC -1'},
        {value: 0, text: 'UTC +0'}, {value:1, text: 'UTC +1'}, {value:2, text: 'UTC +2'}, {value:3, text: 'UTC +3'},
        {value:4, text: 'UTC +4'}, {value:5, text: 'UTC +5'}, {value:6, text: 'UTC +6'}, {value:7, text: 'UTC +7'},
        {value:8, text: 'UTC +8'}, {value:9, text: 'UTC +9'}, {value:10, text: 'UTC +10'},
        {value:11, text: 'UTC +11'}, {value:12, text: 'UTC +12'},
      ]
    },
    disableAddButton() {
      return this.edit.users.length >= (this.$store.getters.getUserOptions.length - 1) || this.$store.getters.getUserId !== this.current_project?.owner_id
    },
  },
  data() {
    return {
      currencies: [],
      validations: {
        title: '',
        company_title: '',
        users: '',
        users_invalid: [],
      },
      countries: [],
      edit: {
        title: '',
        company_title: '',
        office_address: '',
        currency: 'RUB',
        timezone: 3,
        lang: 'RUS',
        users: [
            this.$store.getters.getUserId
        ]
      }
    }
  },
  mounted() {
    this.fetchCountries()
    this.fetchCurrencies()
  },
  watch: {
    'edit.title': function () {
      this.edit.title !== '' && this.titleValid();
    },
    'edit.company_title': function () {
      this.edit.title !== '' && this.company_titleValid() ;
    },
    'current_project': function(p) {
      if(p !== null) {
        this.edit.title = p.title;
        this.edit.company_title = p.company_title || ''
        this.edit.users = p.users.map(({id}) => id);
        this.edit.office_address = p.office_address;
        this.edit.currency = p.currency
        this.edit.timezone = p.timezone
        this.edit.country_id = p.country_id
      } else {
        this.resetEdit();
      }
    }
  },
  methods: {
    userOptions(curr) {
      return this.get_options(this.$store.getters.getUserOptions.filter(({id}) => !this.edit.users.filter(o => o !== curr).includes(id)))
    },
    isState(val) {
      if(val === null) return val;
      if(val?.length) return false;
      return null
    },
    titleValid() {
      this.validations.title = '';
      if (!this.edit.title.trim().length) this.validations.title = this.trans('validation.enter_title');
      return !this.validations.title
    },
    fetchCountries() {
      return this.$http.get('/api/countries').then(({data}) => {
        this.countries = data;
      })
    },
    fetchCurrencies() {
      return this.$http.get('/api/currencies').then(({data}) => {
        this.currencies = data;
      })
    },
    company_titleValid() {
      this.validations.company_title = '';
      if (!this.edit.company_title?.trim().length) this.validations.company_title = this.trans('validation.enter_title');
      return !this.validations.company_title
    },
    usersValid() {
      this.validations.users_invalid = [];
      this.edit.users.forEach((u,i) => u === null && this.validations.users_invalid.push(i))
      return !this.validations.users_invalid.length
    },
    checkValidation() {
      return Object.keys(this.edit).map((f) => {
        if (this[`${f}Valid`]) return this[`${f}Valid`]();
        return true;
      }).every(f => f)
    },
    handleOk() {
      if (!this.checkValidation()) return;
      const data = {...this.edit, users: this.edit.users.filter(v => v), id: this.current_project?.id || null}
      this.$http.post('/api/projects/update', data).then(() => {
        this.$store.dispatch('getIndexAllProjects', {with_archive: true})
      })
      setTimeout(function () {
        this.$bvToast.toast(`${this.trans('common.Project')} «${this.edit.title}» ${this.current_project !== null ? 'обновлен' : 'добавлен'}`, {
          title: this.trans('common.Success'),
          variant: 'success',
          solid: true
        })
        this.$root.$emit('bv::hide::modal', 'add-project-modal');
      }.bind(this), 500)


    },
    getUserLbl(i) {
      return this.edit.users.length > 1 ? `Рекрутер ${i}` : `Рекрутер`;

    },
    addUser() {
      this.edit.users = [...this.edit.users, null]
    },
    deleteUser(i) {
      this.edit.users.splice(i, 1)
    },
    resetValidations() {
      this.validations = {title: '', users: '', users_invalid: [], company_title: ''}
    },
    resetEdit() {
      this.validations = {title: '', users: '', users_invalid: [], company_title: ''}
      this.edit = {
        title: '',
        currency: 'RUB',
        country_id: 1,
        company_title: '',
        users: [this.$store.getters.getUserId],
        office_address: '',
        timezone: '',
        lang: 'RUS'
      }
    }
  },
}
</script>

<style lang="css">
#add-project-modal .add_user_btn_container {display: flex;align-items: center;color: #2591CB;font-weight: 400;font-size: 14px;line-height: 16px;}
#add-project-modal .add_user_btn_container > button {margin-right: 10px;border: none;background: transparent}
#add-project-modal .add_user_btn_container:disabled {color: grey;}
#add-project-modal .add_user_btn_container:hover {text-decoration: underline;cursor: pointer;}
#add-project-modal .add_user_btn_container > button:hover > svg > path {fill: #2591CB}
#add-project-modal .form-group.flex_row > div {display: flex;align-items: center; position: relative;}
#add-project-modal .form-group.flex_row > div > .invalid-feedback {position: absolute; bottom: -16px;}
#add-project-modal .form-group > div > i.icon-trash {margin-left: 12px;}
</style>
